<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <h3 style="line-height:0px;">{{find.place_name}}</h3>
    <p>检查人：{{find.apleet_name}} ，时间：{{find.created_at}}</p>
    <div class="flex mb_20">
      <div class="flex-column">
        <p class="text_align text_danger">新增隐患数</p>
        <div class="xf_relative">
          <div class="xf_text text_danger">
            <span>{{find.new_count}}</span>
          </div>
          <el-progress type="circle" :percentage="percentage" color="red" :show-text="false"></el-progress>
        </div>
      </div>
      <div class="w_10"></div>
      <div class="flex-column">
        <p class="text_align text_primary">复查隐患数</p>
        <div class="xf_relative">
          <div class="xf_text text_primary">
            <span>{{find.review_count}}</span>
          </div>
          <el-progress type="circle" :percentage="percentage" color="#409eff" :show-text="false"></el-progress>
        </div>
      </div>
      <div class="w_10"></div>
      <div class="flex-column">
        <p class="text_align text_success">整改隐患数</p>
        <div class="xf_relative">
          <div class="xf_text text_success">
            <span>{{find.rectify_count}}</span>
          </div>
          <el-progress type="circle" :percentage="percentage" color="#67c23a" :show-text="false"></el-progress>
        </div>
      </div>
    </div>


    <el-card class="box-card" v-for="item in hidden_log" :key="item.id">
      <div slot="header"  class="clearfix">
        <span>{{item.danger}}</span>
        <span style="float: right; padding: 3px 0">{{item.type_name}}</span>
      </div>
      <div class="text item">
         <img class="xf_img" v-for="(item, index) in item.photo" :key="index" :src="item"  alt=""/>
        <p v-if="item.photo_count == 0">暂无图片</p>

        <el-divider></el-divider>
        <div class="xf_title_box">
          <p class="xf_title">检查规则：</p>
          <p>{{item.danger}}</p>
        </div>
        <div class="xf_title_box text_success">
          <p class="xf_title">整改建议：</p>
          <p>{{item.rectification}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【描述详情：{{item.remark}}】</p>
        </div>
      </div>


    </el-card>


    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>

</template>

<script>

export default {
  name: 'l-check-info',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
          setTimeout(() => {
            this.percentage = 100
          }, 100)
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      //表单数据
      form_data: {
      },
      facade_photo: "",
      danger_notification_photo: "",
      signature_photo: "",
      sign_for_photo: "",
      work_photo: "",
      activeName: 'first',
      info_data: {},
      percentage: 0,

      find:{},
      hidden_log:[],
    }
  },
  methods: {
    getData() {
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`placeInspect_getDetails`, { inspect_sn: this.$props.id
        }).then((ret) => {
            this.find = ret.find ;
             this.hidden_log = ret.hidden_log;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
  },
}
</script>